import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatefulLoadingComponent } from './stateful-loading.component';
import { SpinnerModule } from '../spinner/spinner.module';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [StatefulLoadingComponent],
  imports: [CommonModule, SpinnerModule, ButtonModule],
  exports: [StatefulLoadingComponent],
})
export class StatefulLoadingModule {}
